var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import axios from 'axios';
import { container } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { injectable, unmanaged } from 'inversify';
import * as uuid_v4 from 'uuid/v4';
/**
 * Create a new Axios client instance
 * @see https://github.com/mzabriskie/axios#creating-an-instance
 */
var getClient = function (path) {
    if (path === void 0) { path = null; }
    var options = {
        // tslint:disable-next-line:max-line-length
        baseURL: process.env.VUE_APP_API_GATEWAY_SCHEME + "://" + process.env.VUE_APP_API_GATEWAY_HOST + ":" + process.env.VUE_APP_API_GATEWAY_PORT + (process.env.VUE_APP_API_GATEWAY_PATH.length > 0 ? '/' : '') + process.env.VUE_APP_API_GATEWAY_PATH + path,
    };
    var authService = container.get(TYPES.AuthService);
    if (authService.isAuthenticated) {
        options.headers = {
            Authorization: "Bearer " + authService.accessToken,
        };
    }
    var client = axios.create(options);
    // Add a request interceptor
    client.interceptors.request.use(function (requestConfig) { return requestConfig; }, function (requestError) {
        return Promise.reject(requestError);
    });
    // Add a response interceptor
    client.interceptors.response.use(function (response) { return response; }, function (error) {
        return Promise.reject(error);
    });
    return client;
};
var ApiClient = /** @class */ (function () {
    function ApiClient(path) {
        if (path === void 0) { path = null; }
        this.client = getClient(path);
    }
    ApiClient.prototype.get = function (url, conf) {
        if (conf === void 0) { conf = {}; }
        // add correlation guid
        conf.headers = { CorrelationGuid: uuid_v4() };
        return this.client
            .get(url, conf)
            .then(function (response) { return Promise.resolve(response); })
            .catch(function (error) { return Promise.reject(error); });
    };
    ApiClient.prototype.post = function (url, data, conf) {
        if (data === void 0) { data = {}; }
        if (conf === void 0) { conf = {}; }
        // add correlation guid
        conf.headers = { CorrelationGuid: uuid_v4() };
        return this.client
            .post(url, data, conf)
            .then(function (response) { return Promise.resolve(response); })
            .catch(function (error) { return Promise.reject(error); });
    };
    ApiClient = __decorate([
        injectable(),
        __param(0, unmanaged()),
        __metadata("design:paramtypes", [String])
    ], ApiClient);
    return ApiClient;
}());
export { ApiClient };
/**
 * Base HTTP Client
 */
export default {
    // Provide request methods with the default base_url
    get: function (url, conf) {
        if (conf === void 0) { conf = {}; }
        // add correlation guid
        conf.headers = { CorrelationGuid: uuid_v4() };
        return getClient()
            .get(url, conf)
            .then(function (response) { return Promise.resolve(response); })
            .catch(function (error) { return Promise.reject(error); });
    },
    post: function (url, data, conf) {
        if (data === void 0) { data = {}; }
        if (conf === void 0) { conf = {}; }
        // add correlation guid
        conf.headers = { CorrelationGuid: uuid_v4() };
        return getClient()
            .post(url, data, conf)
            .then(function (response) {
            return Promise.resolve(response);
        })
            .catch(function (error) {
            return Promise.reject(error);
        });
    },
};
